import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiCheckCircle, FiHeart } = FiIcons;

const PRESETS = ['3', '5', '10', '25'];

const PWYWModal = ({ isOpen, onClose, onConfirm, itemTitle, suggestedPrice = 5 }) => {
  const [amount, setAmount] = useState(String(suggestedPrice));
  const [status, setStatus] = useState('idle');

  if (!isOpen) return null;

  const handleConfirm = async () => {
    if (!amount || parseFloat(amount) < 0) return;
    setStatus('loading');
    const { error } = await onConfirm(amount);
    if (error) {
      setStatus('error');
      setTimeout(() => setStatus('idle'), 3000);
    } else {
      setStatus('success');
    }
  };

  const handleClose = () => {
    if (status === 'loading') return;
    setStatus('idle');
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center px-6">
      <div onClick={handleClose} className="absolute inset-0 bg-black/90 backdrop-blur-md" />
      <div className="relative w-full max-w-md bg-zinc-900 border border-zinc-800 rounded-[2.5rem] p-10 shadow-2xl">
        {status === 'success' ? (
          <div className="text-center space-y-6 py-10">
            <div className="w-20 h-20 bg-green-500/20 text-green-500 rounded-full flex items-center justify-center mx-auto text-4xl">
              <SafeIcon icon={FiCheckCircle} className="text-4xl" />
            </div>
            <h3 className="text-3xl font-black uppercase tracking-tighter text-white">Access Granted</h3>
            <p className="text-zinc-400 font-bold">Thank you for supporting the artist directly.</p>
            <button onClick={handleClose} className="px-8 py-4 bg-white text-black font-black uppercase tracking-widest text-xs rounded-2xl">
              Close
            </button>
          </div>
        ) : (
          <>
            <button onClick={handleClose} className="absolute top-8 right-8 text-zinc-500 hover:text-white transition-colors text-2xl">
              <SafeIcon icon={FiX} />
            </button>
            <div className="space-y-8">
              <div className="space-y-3">
                <span className="text-xs font-black tracking-widest text-blue-500 uppercase">Support Direct</span>
                <h3 className="text-4xl font-black uppercase tracking-tighter text-white leading-none">
                  Unlock<br />{itemTitle}
                </h3>
              </div>
              <div className="space-y-4">
                <label className="text-xs font-black tracking-widest text-zinc-500 uppercase">Enter Amount (USD)</label>
                <div className="relative">
                  <span className="absolute left-6 top-1/2 -translate-y-1/2 text-2xl font-black text-zinc-500">$</span>
                  <input type="number" value={amount} min="0" step="0.01"
                    onChange={(e) => setAmount(e.target.value)}
                    className="w-full bg-zinc-950 border border-zinc-800 rounded-2xl py-6 pl-12 pr-6 text-3xl font-black text-white focus:border-blue-500 outline-none transition-colors"
                    placeholder="0.00" />
                </div>
                <div className="flex gap-2">
                  {PRESETS.map(val => (
                    <button key={val} onClick={() => setAmount(val)}
                      className={`flex-1 py-3 rounded-xl text-xs font-black uppercase tracking-widest transition-colors ${amount === val ? 'bg-white text-black' : 'bg-zinc-800 hover:bg-zinc-700 text-white'}`}>
                      ${val}
                    </button>
                  ))}
                </div>
              </div>
              <div className="p-5 bg-blue-500/5 rounded-2xl border border-blue-500/10 flex items-start gap-4">
                <SafeIcon icon={FiHeart} className="text-blue-500 text-xl mt-1 flex-shrink-0" />
                <p className="text-sm text-zinc-300 leading-relaxed">100% of this payment goes directly to the artist. No platform fees.</p>
              </div>
              {status === 'error' && (
                <p className="text-red-400 text-xs font-black uppercase tracking-widest text-center">Something went wrong. Try again.</p>
              )}
              <button onClick={handleConfirm} disabled={status === 'loading'}
                className="w-full py-6 bg-white text-black font-black uppercase tracking-widest text-sm rounded-2xl hover:scale-[1.02] active:scale-95 transition-all shadow-xl disabled:opacity-50 disabled:cursor-not-allowed">
                {status === 'loading' ? 'Processing...' : 'Confirm & Unlock'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PWYWModal;